import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en-US.json'
import ru from './locales/ru-RU.json'

const resources = {
  en: { translation: en },
  ru: { translation: ru },
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  lng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
